module.exports = "<div class=\"text-center\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/welcome/welcome.html
// module id = ./src/app/home/welcome/welcome.html
// module chunks = main